import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

let routes = [
	{
		path: '/',
		name: 'home',
		component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
	},
	{
		path: '/:channel(channel[1-9]\\d?)',
		name: 'homechannel',
		component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
		props: true,
		beforeEnter: (to, from, next) => {
			console.log(`访问的是 /${to.params.channel}`)
			next()
		},
	},
	{
		path: '/:channel(channel[1-9]\\d?)/library',
		name: 'librarychannel',
		component: () => import('../pages/library.vue'),
		props: true,
		beforeEnter: (to, from, next) => {
			console.log(`访问的是 /${to.params.channel}`)
			next()
		},
	},
	{
		path: '/library',
		name: 'library',
		component: () => import('../pages/library.vue'),
	},
	{
		path: '/privacy-policy',
		name: 'privacy',
		component: () => import('../pages/privacy.vue'),
	},
	{
		path: '/terms-of-services',
		name: 'terms',
		component: () => import('../pages/terms.vue'),
	},
	{
		path: '/disclaimer',
		name: 'disclaimer',
		component: () => import('../pages/disclaimer.vue'),
	},
	{
		path: '/:channel(channel[1-9]\\d?)/:bookname/:id/:pagenum',
		name: 'detailchannel',
		component: () => import(/* webpackChunkName: "home" */ '../pages/detail.vue'),
		props: true,
		beforeEnter: (to, from, next) => {
			console.log(`访问的是 /${to.params.channel}/${to.params.bookname}/${to.params.id}/${to.params.pagenum}`)
			next()
		},
	},
	{
		path: '/:bookname/:id/:pagenum',
		name: 'detail',
		component: () => import(/* webpackChunkName: "home" */ '../pages/detail.vue'),
	},
	// 添加捕获所有未匹配路由的重定向
	{
		path: '*',
		redirect: '/',
	},
]

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
